import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Car, Clock, ArrowLeft, BookOpen } from "lucide-react";
import { Footer } from "../components/Footer";
import axios from "axios";

const envBackend = process.env.REACT_APP_BACKEND_URL;
const API = envBackend ? `${envBackend}/api` : (window.APP_CONFIG?.API_URL || '/api');

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then(r => setPost(r.data.post)).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-[rgba(138,138,141,0.1)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/">
            <img src="/logo-telobajo-new.png" alt="Te Lo Bajo" className="h-14 sm:h-16 w-auto" />
          </Link>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <Link to="/importacion" className="flex items-center gap-1.5 bg-[#FF3B30] hover:bg-[#E0352B] text-white text-[11px] sm:text-sm font-bold px-2.5 sm:px-4 py-2 rounded-full transition-colors">
              <span className="hidden sm:inline">Importación</span><span className="sm:hidden">Import</span>
            </Link>
            <Link to="/ocasion" className="flex items-center gap-1.5 bg-[#007AFF] hover:bg-[#006AE0] text-white text-[11px] sm:text-sm font-bold px-2.5 sm:px-4 py-2 rounded-full transition-colors">
              <span className="hidden sm:inline">Nacionales</span><span className="sm:hidden">Nacional</span>
            </Link>
            <Link to="/coches-disponibles" className="flex items-center gap-1.5 bg-[#34C759] hover:bg-[#2DB84E] text-white text-[11px] sm:text-sm font-bold px-2.5 sm:px-4 py-2 rounded-full transition-colors">
              <Car className="w-4 h-4" /><span className="hidden sm:inline">Stock</span><span className="sm:hidden">Stock</span>
            </Link>
            <Link to="/blog" className="flex items-center gap-1.5 bg-[#F5A623] hover:bg-[#D4901E] text-white text-[11px] sm:text-sm font-bold px-2.5 sm:px-4 py-2 rounded-full transition-colors">
              <BookOpen className="w-4 h-4" /><span className="hidden sm:inline">Blog</span><span className="sm:hidden">Blog</span>
            </Link>
          </div>
        </div>
      </header>

      <div className="pt-28 pb-20 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto">
          {loading ? (
            <div className="text-center py-20 text-[#8A8A8D]">Cargando...</div>
          ) : !post ? (
            <div className="text-center py-20">
              <p className="text-[#8A8A8D] text-lg mb-4">Entrada no encontrada</p>
              <Link to="/blog" className="text-[#F5A623] hover:underline">Volver al blog</Link>
            </div>
          ) : (
            <article>
              <Link to="/blog" className="inline-flex items-center gap-2 text-[#8A8A8D] hover:text-[#F5A623] text-sm mb-6 transition-colors" data-testid="back-to-blog">
                <ArrowLeft className="w-4 h-4" /> Volver al blog
              </Link>

              {post.tags && post.tags.length > 0 && (
                <div className="flex gap-2 mb-4 flex-wrap">
                  {post.tags.map((tag, i) => (
                    <span key={i} className="text-xs font-semibold uppercase tracking-wider text-[#F5A623] bg-[#F5A623]/10 px-3 py-1 rounded-full">{tag}</span>
                  ))}
                </div>
              )}

              <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-4" data-testid="post-title">{post.title}</h1>

              <div className="flex items-center gap-3 text-[#636366] text-sm mb-8">
                <Clock className="w-4 h-4" />
                {new Date(post.created_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
              </div>

              {post.cover_image && (
                <div className="rounded-2xl overflow-hidden mb-8">
                  <img src={post.cover_image} alt={post.title} className="w-full h-auto" />
                </div>
              )}

              <div
                className="blog-content prose prose-invert max-w-none"
                dangerouslySetInnerHTML={{ __html: post.content }}
                data-testid="post-content"
              />
            </article>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
